import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate, openFile, byteSize } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './maintenance-part.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const MaintenancePartDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const maintenancePartEntity = useAppSelector(state => state.maintenancePart.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="maintenancePartDetailsHeading">
          <Translate contentKey="fleetSenseApp.maintenancePart.detail.title">MaintenancePart</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{maintenancePartEntity.id}</dd>
          <dt>
            <span id="proof">
              <Translate contentKey="fleetSenseApp.maintenancePart.proof">Proof</Translate>
            </span>
          </dt>
          <dd>
            {maintenancePartEntity.proof ? (
              <div>
                {maintenancePartEntity.proofContentType ? (
                  <a onClick={openFile(maintenancePartEntity.proofContentType, maintenancePartEntity.proof)}>
                    <Translate contentKey="entity.action.open">Open</Translate>&nbsp;
                  </a>
                ) : null}
                <span>
                  {maintenancePartEntity.proofContentType}, {byteSize(maintenancePartEntity.proof)}
                </span>
              </div>
            ) : null}
          </dd>
          <dt>
            <span id="objectKey">
              <Translate contentKey="fleetSenseApp.maintenancePart.objectKey">Object Key</Translate>
            </span>
          </dt>
          <dd>{maintenancePartEntity.objectKey}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="fleetSenseApp.maintenancePart.description">Description</Translate>
            </span>
          </dt>
          <dd>{maintenancePartEntity.description}</dd>
          <dt>
            <span id="km">
              <Translate contentKey="fleetSenseApp.maintenancePart.km">Km</Translate>
            </span>
          </dt>
          <dd>{maintenancePartEntity.km}</dd>
          <dt>
            <span id="age">
              <Translate contentKey="fleetSenseApp.maintenancePart.age">Age</Translate>
            </span>
          </dt>
          <dd>{maintenancePartEntity.age}</dd>
          <dt>
            <span id="hour">
              <Translate contentKey="fleetSenseApp.maintenancePart.hour">Hour</Translate>
            </span>
          </dt>
          <dd>{maintenancePartEntity.hour}</dd>
          <dt>
            <span id="replaced">
              <Translate contentKey="fleetSenseApp.maintenancePart.replaced">Replaced</Translate>
            </span>
          </dt>
          <dd>{maintenancePartEntity.replaced ? 'true' : 'false'}</dd>
          <dt>
            <Translate contentKey="fleetSenseApp.maintenancePart.part">Part</Translate>
          </dt>
          <dd>{maintenancePartEntity.part ? maintenancePartEntity.part.name : ''}</dd>
          <dt>
            <Translate contentKey="fleetSenseApp.maintenancePart.maintenanceVehicle">Maintenance Vehicle</Translate>
          </dt>
          <dd>{maintenancePartEntity.maintenanceVehicle ? maintenancePartEntity.maintenanceVehicle.created : ''}</dd>
        </dl>
        <Button tag={Link} to="/maintenance-part" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/maintenance-part/${maintenancePartEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default MaintenancePartDetail;
